// ===========================================
// Consent signal (#442)
// ===========================================
//
// A leaf module (no imports) so the axios interceptor in services/api.ts can tell AuthContext
// that the server answered 403 CONSENT_REQUIRED, without importing React or the context.

type Listener = () => void;

const listeners = new Set<Listener>();

/** Subscribe; returns the unsubscribe function. */
export function onConsentRequired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Called by the API client when a request is refused because the user has not agreed yet. */
export function signalConsentRequired(): void {
  listeners.forEach((listener) => listener());
}
